import { StringUtil } from '@fnv-core/utils';
import { FormControlProps } from '../../../interfaces/FormControlProps';

export class FormControlSpecifics {

  // FormControlSpecifics.proces wordt momenteel alleen maar ingeroepen bij input velden (en dus nog niet voor checkboxen, datepicker, dropdown etc)
  static proces(currentFormControlComponent : React.Component<FormControlProps>, value: any) {
    if (!currentFormControlComponent) {
      return;
    }

    if (currentFormControlComponent.props.formFieldDefinition.name === "Voornaam") {

      const initials: any = currentFormControlComponent.props.formikBag.values["Voorletters"];
      const noInitials: boolean = StringUtil.isNullOrEmpty(initials);
      const voornaam: string = StringUtil.safeValue(value);

      if(voornaam !== "" && noInitials) {
        currentFormControlComponent.props.formikBag.setFieldValue("Voorletters", (voornaam[0] || "").toUpperCase());
      }
    }    
  }
} 